export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATE_WITH_HOUR_FORMAT = 'YYYY-MM-DD hh';
export const DATE_WITH_HOUR_MINUTES_FORMAT = 'YYYY-MM-DD hh:mm';